import React from 'react';

export const FocusAreaDetails = React.lazy(() => import('./pages/FocusAreaDetail'));
